import Profile from './components/Profile';

export const profile = {
  firstLevel: Profile,
};